import { render, staticRenderFns } from "./ConvertPage.vue?vue&type=template&id=84edf0e8&"
import script from "./ConvertPage.vue?vue&type=script&lang=js&"
export * from "./ConvertPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports